/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetAllMealCategoriesAdminResponse } from '../models/GetAllMealCategoriesAdminResponse';
import type { GetMealCategoriesClientResponse } from '../models/GetMealCategoriesClientResponse';
import type { ListOf1OfMealCategoryOperatorListedDto } from '../models/ListOf1OfMealCategoryOperatorListedDto';
import type { MealCategoryAdminDto } from '../models/MealCategoryAdminDto';
import type { MealCategoryClientDto } from '../models/MealCategoryClientDto';
import type { Pagination1OfMealCategoryAdminListedDto } from '../models/Pagination1OfMealCategoryAdminListedDto';
import type { Pagination1OfMealCategoryItemListedAdminDto } from '../models/Pagination1OfMealCategoryItemListedAdminDto';
import type { Pagination1OfMealCategoryMealTierListedAdminDto } from '../models/Pagination1OfMealCategoryMealTierListedAdminDto';
import type { PostMealCategoryRequestAdmin } from '../models/PostMealCategoryRequestAdmin';
import type { PutMealCategoryItemRequestAdmin } from '../models/PutMealCategoryItemRequestAdmin';
import type { PutMealCategoryMealTierRequestAdmin } from '../models/PutMealCategoryMealTierRequestAdmin';
import type { PutMealCategoryOrderRequestAdmin } from '../models/PutMealCategoryOrderRequestAdmin';
import type { PutMealCategoryRequestAdmin } from '../models/PutMealCategoryRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MealCategoriesService {
    /**
     * @returns ListOf1OfMealCategoryOperatorListedDto OK
     * @throws ApiError
     */
    public static getMealCategoriesOperator(): CancelablePromise<ListOf1OfMealCategoryOperatorListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/mealcategories',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns MealCategoryClientDto OK
     * @throws ApiError
     */
    public static getMealCategoryClient({
        id,
    }: {
        id: number,
    }): CancelablePromise<MealCategoryClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/mealcategories/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetMealCategoriesClientResponse OK
     * @throws ApiError
     */
    public static getMealCategoriesClient({
        companyId,
        mealTierId,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        companyId?: number,
        mealTierId?: number,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<GetMealCategoriesClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/mealcategories',
            query: {
                'companyId': companyId,
                'mealTierId': mealTierId,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMealCategories`
     * @returns Pagination1OfMealCategoryAdminListedDto OK
     * @throws ApiError
     */
    public static getMealCategoriesAdmin({
        id,
        enabled,
        isTierFree,
        mealTierId,
        name,
        searchWord,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id?: number,
        enabled?: boolean,
        isTierFree?: boolean,
        mealTierId?: number,
        name?: string,
        searchWord?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfMealCategoryAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/mealcategories',
            query: {
                'id': id,
                'enabled': enabled,
                'isTierFree': isTierFree,
                'mealTierId': mealTierId,
                'name': name,
                'searchWord': searchWord,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMealCategories`
     * @returns MealCategoryAdminDto OK
     * @throws ApiError
     */
    public static postMealCategoryAdmin({
        requestBody,
    }: {
        requestBody?: PostMealCategoryRequestAdmin,
    }): CancelablePromise<MealCategoryAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/mealcategories',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMealCategories`
     * @returns GetAllMealCategoriesAdminResponse OK
     * @throws ApiError
     */
    public static getAllMealCategoriesAdmin({
        enabled,
        isTierFree,
    }: {
        enabled?: boolean,
        isTierFree?: boolean,
    }): CancelablePromise<GetAllMealCategoriesAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/mealcategories/all',
            query: {
                'enabled': enabled,
                'isTierFree': isTierFree,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMealCategoryDetails`
     * @returns MealCategoryAdminDto OK
     * @throws ApiError
     */
    public static getMealCategoryAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<MealCategoryAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/mealcategories/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMealCategories`
     * @returns MealCategoryAdminDto OK
     * @throws ApiError
     */
    public static putMealCategoryAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutMealCategoryRequestAdmin,
    }): CancelablePromise<MealCategoryAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/mealcategories/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteMealCategories`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteMealCategoryAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/mealcategories/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMealCategoryDetails`
     * @returns Pagination1OfMealCategoryItemListedAdminDto OK
     * @throws ApiError
     */
    public static getMealCategoryItemsAdmin({
        id,
        itemId,
        itemName,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id: number,
        itemId?: number,
        itemName?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfMealCategoryItemListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/mealcategories/{id}/items',
            path: {
                'id': id,
            },
            query: {
                'itemId': itemId,
                'itemName': itemName,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMealCategories`
     * @returns any OK
     * @throws ApiError
     */
    public static putMealCategoryItemsAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutMealCategoryItemRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/mealcategories/{id}/items',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMealCategoryDetails`
     * @returns Pagination1OfMealCategoryMealTierListedAdminDto OK
     * @throws ApiError
     */
    public static getMealCategoryMealTiersAdmin({
        id,
        mealTierId,
        mealTierName,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id: number,
        mealTierId?: number,
        mealTierName?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfMealCategoryMealTierListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/mealcategories/{id}/mealtiers',
            path: {
                'id': id,
            },
            query: {
                'mealTierId': mealTierId,
                'mealTierName': mealTierName,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMealCategories`
     * @returns any OK
     * @throws ApiError
     */
    public static putMealCategoryMealTiersAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutMealCategoryMealTierRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/mealcategories/{id}/mealtiers',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMealCategories`
     * @returns any OK
     * @throws ApiError
     */
    public static putMealCategoryOrderAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutMealCategoryOrderRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/mealcategories/{id}/order',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
